<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {useChatStore} from '../core/chatStore';

    const chat = useChatStore();
    const {activeFilters: filters, pending: disabled} = storeToRefs(chat);
</script>

<template>
    <div
        class="chat-pills filters"
        aria-label="Actieve filters">
        <span class="text-muted">Actieve filters:</span>
        <button
            v-for="filter in filters"
            :key="filter.facetKey"
            type="button"
            class="btn btn-default btn-sm"
            :disabled="disabled"
            :aria-label="`Verwijder filter ${filter.label}`"
            @click="chat.removeFilter(filter)">
            <span>{{ filter.label }}: {{ filter.values.join(', ') }}</span>
            <span
                style="padding-left: 4px"
                aria-hidden="true">
                &times;
            </span>
        </button>
    </div>
</template>

<style scoped>
    .filters {
        align-items: center;
    }
</style>
